import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const SmallBox = ({
  transVar
}) => {
  const [t] = useTranslation();

  return (
    <>
      {t(transVar)}
    </>
  );
};

export default SmallBox;